import { render, staticRenderFns } from "./Tab10.vue?vue&type=template&id=62245779&scoped=true"
import script from "./Tab10.vue?vue&type=script&lang=js"
export * from "./Tab10.vue?vue&type=script&lang=js"
import style0 from "./Tab10.vue?vue&type=style&index=0&id=62245779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62245779",
  null
  
)

export default component.exports